import {
  DownloadButtonSwitcher,
  DownloadDropdownSwitcher,
} from '@/components/astro/new-design-25/Downloads/download-switcher';
import * as m from '@/paraglide/messages';

export function DownloadsHero() {
  return (
    <div
      className='mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8'
      itemScope
      itemType='http://schema.org/WebPageElement'
    >
      <section
        aria-labelledby='downloads-heading'
        className='flex flex-col items-center justify-center pt-32 pb-8 text-center sm:pt-40 sm:pb-12 md:pt-48 lg:pt-40 lg:pb-24'
      >
        <h1
          className='mb-4 max-w-xs text-4xl leading-[1.1] font-black sm:mb-6 sm:max-w-2xl sm:text-5xl md:max-w-4xl md:text-6xl lg:text-7xl'
          id='downloads-heading'
          itemProp='headline'
        >
          {m.downloads_hero_title()}
        </h1>
        <p
          className='mb-8 max-w-sm text-base font-semibold text-neutral-665 sm:mb-12 sm:max-w-lg sm:text-lg lg:max-w-2xl lg:text-[20px]'
          itemProp='description'
        >
          {m.downloads_hero_description()}
        </p>

        <div
          aria-label='Download options'
          className='mb-8 flex items-center gap-2'
          role='group'
        >
          <DownloadButtonSwitcher />
        </div>

        <div className='mb-6 text-center text-base leading-[30px] font-normal text-neutral-665'>
          {m.downloads_also_available()}
        </div>

        <div className='flex w-full flex-wrap justify-center gap-4 transition-all md:flex-nowrap md:items-start'>
          <DownloadDropdownSwitcher />
        </div>
      </section>
    </div>
  );
}
